import React from "react";
import { useDeviceType } from "../../../customHooks/useDeviceType";
import { Button, SvgIconHandler } from "../../../atoms";
import "./subscription-success.m.css";

export function SubscriptionSuccess() {
  const isMobile = useDeviceType() !== "desktop";
  const svgDimension = isMobile ? { width: 64, height: 64 } : { width: 88, height: 88 };

  return (
    <div styleName="container">
      <div styleName="message-section">
        <div>
          <SvgIconHandler type="success-circle" width={svgDimension.width} height={svgDimension.height} />
        </div>
        <div>
          <h1 styleName="title">Thank you for placing your order!</h1>
          <p styleName="description">
            We kindly ask for your patience as we process it (approx. 15 min). Please check your email for further
            details and updates.
          </p>
        </div>
      </div>
      <div styleName="action-buttons">
        <Button href="/" customStyleName="bg-brand-primary">
          Go to Home
        </Button>
        <Button href="/profile" customStyleName="">
          Go to Profile
        </Button>
      </div>
    </div>
  );
}
